import { v4 } from 'uuid';

import Configuration from '~/services/configuration';
import { Uuid } from '~/types/Uuid';

import { AgentMessage } from './types';

export const createStreamingMessage = (
  agentExecutionId: string,
): AgentMessage => ({
  id: v4(),
  agentExecutionId: agentExecutionId,
  userType: 'other',
  text: '',
  messageContext: null,
  timestamp: new Date(),
  sources: [],
  citations: [],
  feedbackDetails: undefined,
});

const camelizeEventType = (eventType: string): string => {
  return eventType.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

export const getHandlerName = (eventType: string): string => {
  const camelized = camelizeEventType(eventType);
  return `on${camelized.charAt(0).toUpperCase()}${camelized.slice(1)}`;
};

export const getStreamEndpoint = (id: Uuid) =>
  `${Configuration.sylvanusEndpoint}/api/v1/agent-execution/${id}/ai-message/stream`;
